var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEducation = function SvgEducation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.502 1.799h10.125v.872H4.502v-.872Z",
    fill: "#5C7AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.19 3.375H4.423A1.063 1.063 0 0 1 3.377 2.25a1.125 1.125 0 0 1 1.046-1.125H15.19a.563.563 0 1 0 0-1.125H4.423a2.25 2.25 0 0 0-2.171 2.25 2.325 2.325 0 0 0 0 .276.562.562 0 0 0 0 .135V15.75A2.25 2.25 0 0 0 4.423 18H15.19a.563.563 0 0 0 .562-.563V3.977a.602.602 0 0 0-.563-.602Zm-.563 13.5H4.423a1.125 1.125 0 0 1-1.046-1.125V4.247c.32.176.681.264 1.046.253h10.204v12.375Z",
    fill: "#5C7AFF"
  })));
};

export default SvgEducation;